// app.js
export const SET_LOCALE = 'SET_LOCALE'
export const SET_PRODUCT_ID = 'SET_PRODUCT_ID'
export const SET_DEFAULT_OPTION_ID = 'SET_DEFAULT_OPTION_ID'

export const SET_VIEW = 'SET_VIEW'

export const SET_SETTINGS_LOADING = 'SET_SETTINGS_LOADING'
export const SET_SETTINGS_ERROR = 'SET_SETTINGS_ERROR'

export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS'
export const SET_APPEARANCE_SETTINGS = 'SET_APPEARANCE_SETTINGS'
export const SET_SUPPLIER_SETTINGS = 'SET_SUPPLIER_SETTINGS'
export const SET_DISPLAY_SETTINGS = 'SET_DISPLAY_SETTINGS'

// booking.js
export const SET_OPTION = 'SET_OPTION'

export const UPDATE_ORDER = 'UPDATE_ORDER'
export const CLEAR_ORDER = 'CLEAR_ORDER'

export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
export const CLEAR_CUSTOMER = 'CLEAR_CUSTOMER'

export const REQUEST_INIT_DATA = 'REQUEST_INIT_DATA'
export const REQUEST_INIT_DATA_SUCCESS = 'REQUEST_INIT_DATA_SUCCESS'
export const REQUEST_INIT_DATA_ERROR = 'REQUEST_INIT_DATA_ERROR'

export const REQUEST_CHECK_AVAILABILITY = 'REQUEST_CHECK_AVAILABILITY'
export const REQUEST_CHECK_AVAILABILITY_SUCCESS = 'REQUEST_CHECK_AVAILABILITY_SUCCESS'
export const REQUEST_CHECK_AVAILABILITY_ERROR = 'REQUEST_CHECK_AVAILABILITY_ERROR'
